import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Typography, Box, Paper, Avatar, Grid, Divider, Tab, Tabs, Button } from "@mui/material";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SchoolIcon from '@mui/icons-material/School';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import { Form, Input, MenuSelect, Submit } from "../Form";
import { useForm } from "react-hook-form";
import Records from "./Records";
import { newEvent, addGuest, addUser } from '../../features/records/recordSlice'
import Attendance from "./Attendance";
import moment from 'moment'

const FormRecord = ({ changeConfirm }) => {
    const { event, community } = useSelector(state => state.records);
    const dispatch = useDispatch()
    const [value, setValue] = useState(0);
    const methods = useForm();
    const id = event.id;
    const genders = [{ id: 'H', nombre: 'Hombre'}, { id: 'M', nombre: 'Mujer' }];
    const onSubmit = data => {
        const values = { id, ...data }
        if(value === 0){
            let isRegistered = community.length ? community.some(el => el.codigo === data.codigo) : null
            if(isRegistered) return methods.setError('codigo', { type: 'error', message: `Ya te has registrado previamente al evento!` })
            dispatch(addUser({ values, setError: methods.setError }))
        }else{
            dispatch(addGuest({ values, setError: methods.setError, clearForm: methods.reset }))
        }
    }
    const handleChange = (e, newValue) => {
        setValue(newValue);
        methods.reset()
    }
    return(
        <>
            <Container component={Paper} sx={{ p: '2em' }} maxWidth="xs">
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                    <Avatar sx={{ bgcolor: 'success.main' }} ><EventAvailableIcon /></Avatar>
                    <Typography variant="h4" align="center">{event.tipo}: {event.nombre}</Typography>
                    <Typography variant="h5" align="center">{event.encargado}: {event.responsable}</Typography>
                    <Typography variant="h5" align="center">{event.lugar}</Typography>
                    <Typography variant="span" align="center">{moment(event.fecha).format('LL').toUpperCase()}</Typography>
                    <Typography variant="span" align="center">{event.hora}</Typography>
                </Box>
                <Button onClick={() => dispatch(newEvent())} variant="outlined" sx={{ mb: '1em' }}>Nuevo</Button>
                <Divider light />
                    <Attendance />
                <Divider />
                <Tabs value={value} onChange={handleChange} aria-label="icon label tabs" variant="fullWidth" centered>
                    <Tab icon={<SchoolIcon />} label="CUNorte" />
                    <Tab icon={<EmojiPeopleIcon /> } label="Externo" />
                </Tabs>
                <Form methods={methods} onSubmit={onSubmit}>
                    <Grid container spacing={1}>
                        { value === 0 
                            ? <Input name={'codigo'} min={7} max={9} label={'Código'} regEx={/\w/ig} />
                            : (<>
                                <Input name={'nombre'} label='Nombre' />
                                <Input name={'dependencia'} label='Dependencia' />
                                <MenuSelect name={'genero'} label={'Sexo'} options={genders} val="" id="form" />
                            </>)
                        }
                        <Submit title="Registrar asistencia!" />
                    </Grid>
                </Form>
            </Container>
            <Container sx={{ mt: '2em', mb: '2em' }}>
                <Records changeConfirm={changeConfirm} />
            </Container>
        </>
        
    )
}

export default FormRecord;